import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-stock-reason',
  standalone: true,
  imports: [FormsModule],
  template: `
    <label class="block">
      Reason for stock change
      <select class="select select-bordered w-full" [ngModel]="selection"
        (ngModelChange)="selectReason($event)" [disabled]="disabled" required>
        <option value="" disabled>Choose a reason</option>
        @for (reason of reasons; track reason) {
          <option [value]="reason">{{ reason }}</option>
        }
        <option value="custom">Custom reason</option>
      </select>
    </label>
    @if (selection === 'custom') {
      <label class="block mt-2">
        Custom reason / reference
        <input class="input input-bordered w-full" [ngModel]="customReason"
          (ngModelChange)="updateCustomReason($event)" [disabled]="disabled"
          placeholder="Explain the change (at least 5 characters)" minlength="5" required />
      </label>
    }
  `,
})
export class StockReasonComponent {
  @Input() disabled = false;
  @Output() reasonChange = new EventEmitter<string>();

  readonly reasons = [
    'Physical stock count correction',
    'Damaged items adjustment',
    'Expired items adjustment',
    'Missing stock adjustment',
    'Manual stock entry correction',
  ];
  selection = '';
  customReason = '';

  selectReason(reason: string): void {
    this.selection = reason;
    this.reasonChange.emit(reason === 'custom' ? this.customReason : reason);
  }

  updateCustomReason(reason: string): void {
    this.customReason = reason;
    this.reasonChange.emit(reason);
  }
}
